module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/1ea640707afb7490fd25bb7b6da8260f.png";